// extracted by mini-css-extract-plugin
export default {"modal":"R00g383V"};